import attack from '@/request/request'
import {
  EMER
} from '@/data/requers_variable'

export default {
  // 法律法规的查询
  /*
    /file/guidance/search
   */
  search_file_guidance(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/file/guidance/search/client`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            msg: err.message
          })
        }
      })
    })
  },
  /*
  法律法规的详情
   */
  detail_file_guidance(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/file/guidance/detail`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            msg: err.message
          })
        }
      })
    })
  }, 
  /**
   * 文件下载
   * 
   * @param {any} params 
   * @returns 
   */
  file_download(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/file/guidance/download`,
        data: params,
        success(rep) {
          resolve(true)
        },
        error(err) {
          resolve(false)
        }
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/data/basic/manage/guidefile.js